import { useEffect, useRef } from "react";

const Stories = () => {
  const signupRef = useRef(null); // Reference for Ghost Signup Form container

  useEffect(() => {
    if (!signupRef.current) return;

    // Remove any existing script before adding a new one (prevents duplication)
    signupRef.current.innerHTML = "";

    // Create the script element
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/ghost/signup-form@~0.2/umd/signup-form.min.js";
    script.async = true;
    script.setAttribute("data-button-color", "#0a61cb");
    script.setAttribute("data-button-text-color", "#FFFFFF");
    script.setAttribute("data-site", "https://pocket-ventures-perspectives.ghost.io/");
    script.setAttribute("data-locale", "en");

    signupRef.current.appendChild(script); // Inject the script inside the div

    return () => {
      if (signupRef.current) {
        signupRef.current.innerHTML = ""; // Cleanup on unmount
      }
    };
  }, []);

  return (
    <>
      <section className="WhatPrcog Stories" id="newsletter">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h6>Pocket Notes blog</h6>
                <h4>Our Newsletter</h4>
                <p>
                  Subscribe to Pocket Notes for Pocket's posts on community,
                  capital, and culture.
                </p>
              </div>
            </div>
          </div>
          <div className="row flex justify-content-center align-items-center">
            <div className="col-11 col-sm-8 col-md-6 col-lg-4">
              {/* Ghost Signup Form will be injected here */}
              <div ref={signupRef} style={{ marginTop: "20px" }}></div>

              <div className="row">
                <div className="col-12 d-flex justify-content-center align-items-center">
                  <div >
                    We care about your data in our{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                      privacy policy
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Stories;
